import { useState, useEffect } from "react";
import styles from "./ActivityFeed.module.css";

const RPC = "https://terra-rpc.polkachu.com";
const CONTRACTS = [
  "terra1h4cknjl5k0aysdhv0h4eqcaka620g8h69k8h0pjjccxvf9esfhws3cyqnc",
  "terra10qnsw3wn4uaxs7en2kynhet2dsyy76lmprh2ptcz85d8hu59gkuqcpndnv",
  "terra1sf66d5vap897xlvv2hlcp4l20y4pp42r6ala4snk8mgd246jvufqwe0cnm",
];

const ACTION_LABELS = {
  provide_collateral: { text: "deposited collateral", icon: "💎" },
  borrow_stable: { text: "borrowed SOLID", icon: "🏦" },
  repay_stable: { text: "repaid SOLID", icon: "✅" },
  withdraw_collateral: { text: "withdrew collateral", icon: "📤" },
  stake_voting_tokens: { text: "staked CAPA", icon: "🗳" },
  cast_vote: { text: "voted on proposal", icon: "🗳" },
  claim: { text: "claimed rewards", icon: "🎁" },
  submit_bid: { text: "placed liquidation bid", icon: "⚡" },
  lock_collateral: { text: "locked collateral", icon: "🔒" },
  unlock_collateral: { text: "unlocked collateral", icon: "🔓" },
};

function truncAddr(addr) {
  if (!addr || addr.length < 15) return addr || "";
  return addr.slice(0, 8) + "..." + addr.slice(-4);
}

function timeAgo(ts) {
  const diff = Math.floor(Date.now() / 1000 - ts);
  if (diff < 60) return "just now";
  if (diff < 3600) return Math.floor(diff / 60) + "m ago";
  if (diff < 86400) return Math.floor(diff / 3600) + "h ago";
  return Math.floor(diff / 86400) + "d ago";
}

export default function ActivityFeed() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchActivity() {
      try {
        const allEvents = [];

        for (const contract of CONTRACTS) {
          try {
            const q = "wasm._contract_address='" + contract + "'";
            const url = RPC + "/tx_search?query=%22" + encodeURIComponent(q) + "%22&per_page=5&order_by=%22desc%22";
            const res = await fetch(url, { signal: AbortSignal.timeout(8000) });
            const data = await res.json();

            for (const tx of data.result?.txs || []) {
              // Parse tx result events
              const txHash = tx.hash || "";
              const height = tx.height || "0";

              for (const evt of tx.tx_result?.events || []) {
                if (evt.type === "wasm") {
                  let action = null;
                  let sender = null;

                  for (const attr of evt.attributes || []) {
                    const key = attr.key || "";
                    const val = attr.value || "";
                    if (key === "action") action = val;
                    if (key === "sender" || key === "borrower" || key === "staker") sender = val;
                  }

                  if (action && ACTION_LABELS[action]) {
                    allEvents.push({
                      id: txHash + action,
                      address: sender || "",
                      action,
                      label: ACTION_LABELS[action],
                      height: parseInt(height),
                      time: Math.floor(Date.now() / 1000) - (parseInt(height) > 0 ? (20487000 - parseInt(height)) * 6 : 0),
                      hash: txHash,
                    });
                  }
                }
              }
            }
          } catch {
            // Skip failed queries
          }
        }

        // Deduplicate
        const seen = new Set();
        const unique = allEvents.filter((e) => {
          if (seen.has(e.id)) return false;
          seen.add(e.id);
          return true;
        });
        unique.sort((a, b) => b.height - a.height);

        setEvents(unique.slice(0, 10));
      } catch {
        // Silent fail
      }
      setLoading(false);
    }

    fetchActivity();
    const interval = setInterval(fetchActivity, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading || events.length === 0) return null;

  return (
    <section className={styles.feed}>
      <h2 className={styles.feedTitle}>
        <span className={styles.liveDot} />
        Live Protocol Activity
      </h2>
      <div className={styles.feedList}>
        {events.map((e, i) => (
          <div
            key={e.id}
            className={styles.feedItem}
            style={{ animationDelay: i * 0.05 + "s" }}
          >
            <span className={styles.feedIcon}>{e.label.icon}</span>
            <span className={styles.feedAddr}>{truncAddr(e.address)}</span>
            <span className={styles.feedAction}>{e.label.text}</span>
            <span className={styles.feedTime}>{timeAgo(e.time)}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
